import Navbar from "../../components/Navbar/Navbar";
import Cabecalho from "../../components/Cabecalho";
import { useContext, useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import styles from "./styles.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import RowPlanoDeTrabalho from "../../components/TableConstructor/Row/RowPlanoDeTrabalho";
import getPlanosDeTrabalhoPorModalidade from "../../services/getPlanosTrabalhoPorModalidade";
import { PlanoDeTrabalho } from "../../model/PlanoDeTrabalho";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import {
  MetaAplicacaoRecurso,
  ReceitaDespesa,
} from "../../model/PlanoDeTrabalho/PlanoAplicacao";
import { Equipamento } from "../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import TabelaPaginacao from "../../components/TableConstructor/TabelaPaginacao";

type Plano = {
  id: number;
  instituicao_id: number;
  planoDeTrabalho: PlanoDeTrabalho;
  metasFisicas: MetaFisica[];
  metasAplicacoes: MetaAplicacao[];
  metasAplicacaoRecurso: MetaAplicacaoRecurso[];
  receitasDespesas: ReceitaDespesa[];
  equipamentos: Equipamento[];
};

function PlanosDeTrabalho() {
  const [listaPlanos, setListaPlanos] = useState<Plano[]>([]);
  const [lastPage, setLastPage] = useState(0);
  const [page, setPage] = useState(1);

  const { token } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  
  
  useEffect(() => {
    const listarplanos = async () => {
      try {
        const response = await getPlanosDeTrabalhoPorModalidade(token, state.modalidade, page);
        const planos = response.data;
        setLastPage(response.last_page);
        const listaDePlanos: Plano[] = [];
        for (let i = 0; i < planos.length; i++) {
          const metasFisicas: MetaFisica[] = [];
          const metasAplicacaoRecurso: MetaAplicacaoRecurso[] = [];
          const metasAplicacaoFinanceira: MetaAplicacao[] = [];
          const receitasDespesas: ReceitaDespesa[] = [];
          const equipamentos: Equipamento[] = [];

          const execucaoFisica = planos[i].metas_de_execucao_fisico;

          for (let j = 0; j < execucaoFisica.length; j++) {
            metasFisicas.push({
              etapa: execucaoFisica[j].etapa,
              fase: execucaoFisica[j].fase,
              inicio: execucaoFisica[j].inicio,
              fim: execucaoFisica[j].fim,
              unidade_medida: execucaoFisica[j].unidade_medida,
              quantidade: execucaoFisica[j].quantidade,
              descricao: execucaoFisica[j].descricao,
            });

            const aplicacaoRecurso =
              execucaoFisica[j].metas_de_aplicacao_de_recursos || [];
            const aplicacaoFinanceira =
              execucaoFisica[j].metas_de_aplicacao_financeira || [];
            const receita = execucaoFisica[j].receitas_despesas || [];
            const equipamentosLista = execucaoFisica[j].equipamentos || [];
            for (let k = 0; k < aplicacaoRecurso.length; k++) {
              metasAplicacaoRecurso.push({
                meta_execucao_fisico_id: j,
                tipo: aplicacaoRecurso[k].tipo,
                etapa: aplicacaoRecurso[k].etapa,
                fase: aplicacaoRecurso[k].fase,
                custo_unitario: aplicacaoRecurso[k].custo_unitario,
                unidade_medida: aplicacaoRecurso[k].unidade_medida,
                quantidade: aplicacaoRecurso[k].quantidade,
                especificacao: aplicacaoRecurso[k].especificacao,
                valor_parceiro_privado:
                  aplicacaoRecurso[k].valor_parceiro_privado,
                valor_parceiro_publico:
                  aplicacaoRecurso[k].valor_parceiro_publico,
              });
            }
            for (let k = 0; k < aplicacaoFinanceira.length; k++) {
              metasAplicacaoFinanceira.push({
                meta_execucao_fisico_id: j,
                tipo: aplicacaoFinanceira[k].tipo,
                especificacao: aplicacaoFinanceira[k].especificacao,
                valor_orgao_entidade:
                  aplicacaoFinanceira[k].valor_orgao_entidade,
                valor_organizacao_sociedade_civil:
                  aplicacaoFinanceira[k].valor_organizacao_sociedade_civil,
              });
            }
            for (let k = 0; k < receita.length; k++) {
              receitasDespesas.push({
                tipo: receita[k].tipo,
                meta_execucao_fisico_id: j,
                orgao: receita[k].orgao,
                etapa: receita[k].etapa,
                fase: receita[k].fase,
                ano: receita[k].ano,
                mes: receita[k].mes,
                total_meta: receita[k].total_meta,
              });
            }
            for (let k = 0; k < equipamentosLista.length; k++) {
              equipamentos.push({
                meta_execucao_fisico_id: j,
                nome_especificacao: equipamentosLista[k].nome_especificacao,
                quantidade: equipamentosLista[k].quantidade,
                valor_unidade: equipamentosLista[k].valor_unidade,
                valor_total: equipamentosLista[k].valor_total,
              });
            }
          }

          listaDePlanos.push({
            id: planos[i].id,
            instituicao_id: planos[i].edital_id,
            planoDeTrabalho: {
              id: planos[i].id,
              edital_id: planos[i].edital_id || undefined,
              titulo_projeto: planos[i].titulo_projeto,
              modalidade: planos[i].modalidade,
              orgao_financiador: planos[i].orgao_financiador,
              objeto_parceria: planos[i].objeto_parceria,
              area_atendimento: planos[i].area_atendimento,
              inicio: planos[i].inicio,
              fim: planos[i].fim,
              situacao: planos[i].situacao,
              descricao_realidade: planos[i].descricao_realidade,
              forma_execucao: planos[i].forma_execucao,
              descricao_metas: planos[i].descricao_metas,
              indicadores: planos[i].indicadores,
              manutencao_equipamentos: planos[i].manutencao_equipamentos,
            },
            metasFisicas: metasFisicas,
            metasAplicacaoRecurso: metasAplicacaoRecurso,
            metasAplicacoes: metasAplicacaoFinanceira,
            receitasDespesas: receitasDespesas,
            equipamentos: equipamentos,
          });
        }
        setListaPlanos(listaDePlanos);
      } catch (error) {
        console.error("Erro ao buscar Planos de Trabalho", error);
      }
    };
    listarplanos();
  }, [page, state.modalidade]);

  return (
    <div className={styles.page}>
      <Navbar activeIndex={state.indexNavbar} />
      <section>
        <Cabecalho
          title={state.title}
          icon={state.icon}
        />
        <main>
          <div className={styles.container}>
            <div hidden={listaPlanos.length === 0}>
              <h3>Projetos recebidos</h3>
              <TabelaPaginacao
                listTitle={["Titulo", "Modalidade", "Area", "Duração", "Situação", ""]}
                styleList={[0, 1, 1, 1, 1]}
                lastPage={lastPage}
                setPage={setPage}
                atualPage={page}
                paginacao
              >
                {listaPlanos.length > 0 &&
                  listaPlanos.map((plano, index) => (
                    <RowPlanoDeTrabalho
                      titulo={plano.planoDeTrabalho.titulo_projeto}
                      modalidade={plano.planoDeTrabalho.modalidade}
                      area={plano.planoDeTrabalho.area_atendimento}
                      inicio={new Date(Date.now())}
                      fim={new Date(Date.now())}
                      situacao={plano.planoDeTrabalho.situacao}
                      key={index}
                    >
                      <button
                        className={styles.viewButton}
                        onClick={(e) => {
                          e.preventDefault();

                          navigate(`proposta/${plano.id}`, {
                            state: {
                              planoDeTrabalho: plano.planoDeTrabalho,
                              metasFisicas: plano.metasFisicas,
                              metasAplicacoes: plano.metasAplicacoes,
                              metasAplicacaoRecurso: plano.metasAplicacaoRecurso,
                              receitasDespesas: plano.receitasDespesas,
                              equipamentos: plano.equipamentos,
                              modalidade: state.modalidade, 
                              indexNavbar: state.indexNavbar, 
                              icon: state.icon, 
                              title: state.title
                            },
                          });
                        }}
                      >
                        Visualizar
                      </button>
                    </RowPlanoDeTrabalho>
                  ))}
              </TabelaPaginacao>
            </div>
            <h3 hidden={listaPlanos.length !== 0}>Sem propostas submetidas </h3>
          </div>
        </main>
      </section>
    </div>
  );
}

export default PlanosDeTrabalho;
